module.exports = __webpack_public_path__ + "img/走进子拓s.6f614753.png";